/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { GET_DASHBOARD_OVERVIEW_SUCCESS } from "../actions/asset/assetActionTypes";
import { GET_PARTNER_DASHBOARD_STATS_SUCCESS } from "../actions/actionTypes";

const initialState = {
  isGetDashboardSuccess: false,
  data: null,
  widgetData: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_OVERVIEW_SUCCESS:
      return {
        ...state,
        isGetDashboardSuccess: true,
        data: action.payload.data,
      };
    case GET_PARTNER_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        widgetData: action.payload,
      };
    default:
      return state;
  }
}
